import { render, staticRenderFns } from "./TrueCrime.vue?vue&type=template&id=03e7c3ad&"
import script from "./TrueCrime.vue?vue&type=script&lang=js&"
export * from "./TrueCrime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports